import React from "react";
import { Badge, Card } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import dayjs from "dayjs";
import { formatTime12h } from "../../../utils/formatTime";
import { TopicInfoTrigger } from "../../../components/TopicInfoTrigger";
import { LevelBadge } from "../../../components/LevelBadge";

// Backend status: "active" = fecha futura, "draft" = fecha ya pasada.
const STATUS_VARIANT = {
  active: "success",
  cancelled: "secondary",
  draft: "secondary",
};

const STATUS_LABEL = {
  active: "Programada",
  cancelled: "Cancelada",
  draft: "Finalizada",
};

function ClassCard({ planning, colClassName = "col-12 col-sm-6 col-xl-4 mb-3" }) {
  const { slug } = useParams();
  const topics = planning.topics ?? [];
  const statusVariant = STATUS_VARIANT[planning.status] ?? "secondary";
  const statusLabel = STATUS_LABEL[planning.status] ?? "Finalizada";

  return (
    <div className={colClassName}>
      {/* Toda la tarjeta es clicable → abre el detalle de la clase. */}
      <Link
        to={`/${slug}/app/agenda/${planning.id}`}
        className="text-decoration-none text-reset d-block h-100"
        aria-label={`Ver clase ${
          topics.length > 0 ? topics.map((t) => t.name ?? t).join(", ") : ""
        }`}
      >
        <Card className={`h-100 card-clickable shadow-sm border-start border-4 border-${statusVariant}`}>
          <Card.Body>
            <div className="d-flex justify-content-between align-items-start mb-2">
              <div>
                <Card.Title className="mb-0 fs-6 d-flex align-items-center gap-1">
                  <span>
                    {topics.length > 0
                      ? topics.map((t) => t.name ?? t).join(", ")
                      : "Sin tema"}
                  </span>
                  <TopicInfoTrigger topics={topics} />
                </Card.Title>
                <small className="text-muted">
                  {dayjs(planning.date).format("ddd D MMM")}
                  {planning.time_start ? ` · ${formatTime12h(planning.time_start)}` : ""}
                  {planning.duration ? ` · ${planning.duration} h` : ""}
                  {planning.place ? ` · ${planning.place}` : ""}
                </small>
                {planning.level && (
                  <div className="mt-1">
                    <LevelBadge level={planning.level} />
                  </div>
                )}
              </div>
              <Badge bg={statusVariant}>{statusLabel}</Badge>
            </div>
            <div className="d-flex justify-content-between align-items-center mt-3">
              <small className="text-muted">
                {planning.enrolled_count ?? 0} inscritos
              </small>
              <small className="text-primary fw-medium">
                Ver clase <i className="mdi mdi-chevron-right" aria-hidden="true" />
              </small>
            </div>
          </Card.Body>
        </Card>
      </Link>
    </div>
  );
}

export { ClassCard };
